
const VERSION = {
  SHA1:'13750d31ffbc35230d264c2f491aae2b3376140f',
  VERSION:2319,
  BRANCH:'main',
  PROJECT:'ostium-ne'
}
export default VERSION;
